import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Fab from '@material-ui/core/Fab';
import FormControl from '@material-ui/core/FormControl';
import moment from 'moment';
import InputLabel from '@material-ui/core/InputLabel';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
import Calendar from 'modules/shared/components/_employee-views/Calendar/DatePicker/Calendar';

const AllocationsFilters = props => {
  const isFilterActive = Object.values(props?.filterForm).some(
    value => value !== '' && value !== null
  );
  return (
    <div
      id="employeeFilterForm"
      style={{ display: 'flex', width: '100%', alignItems: 'center', flexDirection: 'column' }}
    >
      <div
        style={{ display: 'flex', width: '100%', alignItems: 'center', margin: '-3rem 0 1rem 0' }}
      >
        <FormControl style={{ flex: '1 0', marginRight: '0.25em', marginBottom: '5.5px' }}>
          <InputLabel id="level-select-label">Client Name</InputLabel>
          <Select
            disabled={props?.clients?.length === 0}
            MenuProps={{
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left'
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'left'
              },
              getContentAnchorEl: null
            }}
            labelId="client-name-select-label"
            id="client-name-select"
            value={props?.filterForm?.clientId}
            onChange={props?.handleChange}
            name="clientId"
          >
            <MenuItem value={''} disabled={!props?.clients}>
              Clear Filter
            </MenuItem>

            {props?.clients?.map(option => (
              <MenuItem key={option?.id} value={option?.id}>
                {option?.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl style={{ flex: '1 0', marginRight: '0.25em', marginBottom: '5.5px' }}>
          <InputLabel id="level-select-label">Project Name</InputLabel>
          <Select
            disabled={props?.filterForm?.clientId === ''}
            MenuProps={{
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left'
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'left'
              },
              getContentAnchorEl: null
            }}
            labelId="project-select-label"
            id="project-select"
            value={props?.filterForm?.projectId}
            onChange={props?.handleChange}
            name="projectId"
          >
            <MenuItem value={''} disabled={!props?.filterForm?.yearsOfExperience}>
              Clear Filter
            </MenuItem>

            {props?.clientProjects?.map(option => (
              <MenuItem key={option?.id} value={option?.id}>
                {option?.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl style={{ flex: '1 0', marginRight: '0.25em', marginBottom: '13.5px' }}>
          <Calendar
            handleChange={date => props?.dateHandleChange('startDate', moment(date))}
            date={props?.filter?.startDate.toISOString() || undefined}
            placeholder="Start Date"
            fullWidth={true}
            name="startDate"
          />
        </FormControl>
        <FormControl style={{ flex: '1 0', marginRight: '0.25em', marginBottom: '13.5px' }}>
          <Calendar
            handleChange={date => props?.dateHandleChange('endDate', moment(date))}
            date={props?.filter?.startDate.toISOString() || undefined}
            placeholder="End Date"
            fullWidth={true}
            name="endDate"
          />
        </FormControl>
        <Fab
          disabled={!isFilterActive}
          onClick={() => {
            props?.applyFilter();
            // props?.addSkillColumns();
          }}
          size="small"
          className={!isFilterActive ? 'disabledBtn' : 'enabledBtn'}
        >
          <CheckIcon />
        </Fab>
        <Fab
          disabled={props?.filterForm?.skill?.length === 0}
          onClick={props?.clearFilter}
          size="small"
          className={props?.filterForm?.skill?.length === 0 ? 'clear disabled' : 'clear'}
        >
          <ClearIcon />
        </Fab>
      </div>
    </div>
  );
};

export default AllocationsFilters;
